import { makeStyles } from '@material-ui/core/styles';
import _uniq from 'lodash/uniq';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../app/theme';
import { setNodeById, setSelectedNode } from '../../features/mainSlice';
import { findTag } from '../../features/organizationSlice';
import AutoCompleted from '../shared/AutoCompleted';
import Tag from '../shared/Tag';
import Mask from './SettingBarMask';

const useStyles = makeStyles(
  {
    top: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      background: color.$9,
      textAlign: 'center',
      padding: '18px 0 21px',
    },
    bottom: {
      padding: '24px 16px',
      overflowY: 'auto',
      height: 'calc(100vh - 170px)',
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 8,
    },
    tag: {
      marginBottom: 8,
    },
    targetInput: {
      width: '100%',
    },
    title: {
      fontSize: '15px',
      fontWeight: '400',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '21px',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 12,
    },
  },
  {
    name: 'TagSettingBar',
  },
);

const TagSettingBar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode, isErrorNodeIds } = useSelector(state => state.ma);
  const { objectId: orgId, tagCandidates } = useSelector(
    store => store.organization,
  );
  const { data } = selectedNode || {};
  const { tags } = data || {};
  const isError = !!~isErrorNodeIds.indexOf(selectedNode?.id);

  const handleChangeTag = tagName => {
    dispatch(findTag(tagName, orgId));
  };

  const onRemoveValue = value => {
    const newNode = {
      ...selectedNode,
      data: {
        ...data,
        tags: tags.filter(tag => tag !== value),
      },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  const onChangeTag = value => {
    const newNode = {
      ...selectedNode,
      data: {
        ...data,
        tags: _uniq([...tags, value]),
      },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  useEffect(() => {
    dispatch(findTag('', orgId));
  }, []);

  return (
    <>
      <div className={classes.top}>{t('tag-node')}</div>
      <div id="tag-setting-bar-bottom" className={classes.bottom}>
        <div>
          <div className={classes.title}>{t('trigger.tag')}</div>
          <div className={classes.row}>
            <AutoCompleted
              className={classes.targetInput}
              placeholder={t('trigger-setting.tags-placeholder')}
              candidates={tagCandidates.filter(
                c => !~(tags || []).indexOf(c?.name),
              )}
              onFocus={() => {}}
              onChange={handleChangeTag}
              onEnter={value => onChangeTag(value)}
              isError={isError && !tags.length}
              notNull
            />
          </div>
          <div>
            {(tags || []).map((tag, idx) => (
              <Tag
                className={classes.tag}
                size="M"
                tag={tag}
                key={`tags-${idx}`}
                clickable
                idx={idx}
                color="colorPrimary"
                onDeleteFunction={onRemoveValue}
                deleteable
              />
            ))}
          </div>
        </div>
      </div>
      <Mask mainId="tag-setting-bar-bottom" />
    </>
  );
};

export default TagSettingBar;
